const carExtrasGroups = {
    "0": {
        "name": "carExtraAbs",
        "category": "carExtraGroupSafetySecurity"
    },
    "1": {
        "name": "carExtraAdaptiveLighting",
        "category": "carExtraGroupLightingVisibility"
    },
    "2": {
        "name": "carExtraAlarmSystem",
        "category": "carExtraGroupSafetySecurity"
    },
    "3": {
        "name": "carExtraAlloyWheels",
        "category": "carExtraGroupExteriorWheels"
    },
    "4": {
        "name": "carExtraAndroidAuto",
        "category": "carExtraGroupInfotainment"
    },
    "5": {
        "name": "carExtraAppleCarplay",
        "category": "carExtraGroupInfotainment"
    },
    "6": {
        "name": "carExtraArmRest",
        "category": "carExtraGroupComfortInterior"
    },
    "7": {
        "name": "carExtraBiXenonHeadlights",
        "category": "carExtraGroupLightingVisibility"
    },
    "8": {
        "name": "carExtraBlindSpotAssist",
        "category": "carExtraGroupSafetySecurity"
    },
    "9": {
        "name": "carExtraBluetooth",
        "category": "carExtraGroupInfotainment"
    },
    "10": {
        "name": "carExtraCdPlayer",
        "category": "carExtraGroupInfotainment"
    },
    "11": {
        "name": "carExtraCentralLocking",
        "category": "carExtraGroupSafetySecurity"
    },
    "12": {
        "name": "carExtraDistanceWarningSystem",
        "category": "carExtraGroupSafetySecurity"
    },
    "13": {
        "name": "carExtraElectricBackseatAdjustment",
        "category": "carExtraGroupComfortInterior"
    },
    "14": {
        "name": "carExtraElectricSeatAdjustment",
        "category": "carExtraGroupComfortInterior"
    },
    "15": {
        "name": "carExtraElectricSideMirror",
        "category": "carExtraGroupExteriorWheels"
    },
    "16": {
        "name": "carExtraElectricWindows",
        "category": "carExtraGroupComfortInterior"
    },
    "17": {
        "name": "carExtraEmergencyBrakeAssist",
        "category": "carExtraGroupSafetySecurity"
    },
    "18": {
        "name": "carExtraEmergencyTyre",
        "category": "carExtraGroupEmergencyUtility"
    },
    "19": {
        "name": "carExtraEmergencyTyreRepairKit",
        "category": "carExtraGroupEmergencyUtility"
    },
    "20": {
        "name": "carExtraEsp",
        "category": "carExtraGroupSafetySecurity"
    },
    "21": {
        "name": "carExtraFatigueWarningSystem",
        "category": "carExtraGroupSafetySecurity"
    },
    "22": {
        "name": "carExtraFogLamps",
        "category": "carExtraGroupLightingVisibility"
    },
    "23": {
        "name": "carExtraFoldingExteriorMirrors",
        "category": "carExtraGroupExteriorWheels"
    },
    "24": {
        "name": "carExtraFoldingRoof",
        "category": "carExtraGroupExteriorWheels"
    },
    "25": {
        "name": "carExtraFourWheelDrive",
        "category": "carExtraGroupPerformance"
    },
    "26": {
        "name": "carExtraHeadUpDisplay",
        "category": "carExtraGroupInfotainment"
    },
    "27": {
        "name": "carExtraHeadlightWasherSystem",
        "category": "carExtraGroupLightingVisibility"
    },
    "28": {
        "name": "carExtraHeatedRearSeats",
        "category": "carExtraGroupComfortInterior"
    },
    "29": {
        "name": "carExtraHeatedSeats",
        "category": "carExtraGroupComfortInterior"
    },
    "30": {
        "name": "carExtraHeatedSteeringWheel",
        "category": "carExtraGroupComfortInterior"
    },
    "31": {
        "name": "carExtraHeatedWindshield",
        "category": "carExtraGroupComfortInterior"
    },
    "32": {
        "name": "carExtraHillStartAssist",
        "category": "carExtraGroupPerformance"
    },
    "33": {
        "name": "carExtraIsofix",
        "category": "carExtraGroupSafetySecurity"
    },
    "34": {
        "name": "carExtraKeylessEntry",
        "category": "carExtraGroupSafetySecurity"
    },
    "35": {
        "name": "carExtraLeatherSeats",
        "category": "carExtraGroupComfortInterior"
    },
    "36": {
        "name": "carExtraLedHeadlights",
        "category": "carExtraGroupLightingVisibility"
    },
    "37": {
        "name": "carExtraNavigationSystem",
        "category": "carExtraGroupInfotainment"
    },
    "38": {
        "name": "carExtraPanoramicRoof",
        "category": "carExtraGroupExteriorWheels"
    },
    "39": {
        "name": "carExtraParkingAssist",
        "category": "carExtraGroupParking"
    },
    "40": {
        "name": "carExtraParkingSensors",
        "category": "carExtraGroupParking"
    },
    "41": {
        "name": "carExtraPowerSteering",
        "category": "carExtraGroupPerformance"
    },
    "42": {
        "name": "carExtraPrivacyGlass",
        "category": "carExtraGroupExteriorWheels"
    },
    "43": {
        "name": "carExtraRainSensor",
        "category": "carExtraGroupSafetySecurity"
    },
    "44": {
        "name": "carExtraRearViewCamera",
        "category": "carExtraGroupSafetySecurity"
    },
    "45": {
        "name": "carExtraSeatVentilation",
        "category": "carExtraGroupComfortInterior"
    },
    "46": {
        "name": "carExtraSideAirbags",
        "category": "carExtraGroupSafetySecurity"
    },
    "47": {
        "name": "carExtraSlidingDoors",
        "category": "carExtraGroupExteriorWheels"
    },
    "48": {
        "name": "carExtraSoundSystem",
        "category": "carExtraGroupInfotainment"
    },
    "49": {
        "name": "carExtraSportSeats",
        "category": "carExtraGroupComfortInterior"
    },
    "50": {
        "name": "carExtraStartStopSystem",
        "category": "carExtraGroupPerformance"
    },
    "51": {
        "name": "carExtraSunroof",
        "category": "carExtraGroupExteriorWheels"
    },
    "52": {
        "name": "carExtraTractionControl",
        "category": "carExtraGroupSafetySecurity"
    },
    "53": {
        "name": "carExtraUsb",
        "category": "carExtraGroupInfotainment"
    },
    "54": {
        "name": "carExtraXenonHeadlights",
        "category": "carExtraGroupLightingVisibility"
    },
    "55": {
        "name": "carExtraAdaptiveCruiseControl",
        "category": "carExtraGroupPerformance"
    },
    "56": {
        "name": "carExtraAutomaticParking",
        "category": "carExtraGroupParking"
    },
    "57": {
        "name": "carExtraLaneDepartureWarning",
        "category": "carExtraGroupSafetySecurity"
    },
    "58": {
        "name": "carExtraParkingCamera",
        "category": "carExtraGroupParking"
    },
    "59": {
        "name": "carExtraSurroundViewCamera",
        "category": "carExtraGroupSafetySecurity"
    }
};

export default carExtrasGroups;